import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export interface WebserviceProjectResponse {
    files: Record<string, string>;
    images: {
        name: string;
        url: string;
    }[];
    latest_answer: null | {
        files: Record<string, string>;
    };
}

export function getWebserviceProject(project: string): Promise<WebserviceProjectResponse> {
    const { apiGetWebserviceProject } = apiConfig.getStaticUrls();

    return getFetch(apiGetWebserviceProject, { project });
}
